/**
 * Tracking constants for the audit feature.
 *
 * Uses INTERACTION_TYPES from shared/observability for the event `type`.
 * Defines audit-specific page identifiers and action names.
 */

/** Page identifiers for audit-related screens. */
export const AUDIT_PAGES = {
  detail: 'audit-detail',
  list: 'audit-list',
  perform: 'audit-perform',
} as const;

/** Action names used in `type: 'action_triggered'` events. */
export const AUDIT_ACTIONS = {
  startAudit: 'start_audit',
  continueAudit: 'continue_audit',
  viewAudit: 'view_audit',
  manageAssignees: 'manage_assignees',
  cancelAuditConfirmed: 'cancel_audit_confirmed',
  reopenAuditConfirmed: 'reopen_audit_confirmed',
  closeAuditConfirmed: 'close_audit_confirmed',
  answerQuestion: 'answer_question',
  // PA-04 toggle-off — fired when re-tapping the selected answer
  // clears it. Distinct from answerQuestion so dashboards can
  // separate corrections from first-pass answering.
  answerCleared: 'answer_cleared',
  createTask: 'create_task',
  // Manual refresh from the audit list — same spelling as
  // TASK_ACTIONS.refreshList so cross-feature RUM dashboards can
  // aggregate on the shared action name.
  refreshList: 'refresh_list',
  // Per-question language picker on the perform-audit page — mirrors
  // TASK_ACTIONS.languageChanged so cross-feature RUM dashboards
  // aggregate on the shared action name.
  languageChanged: 'language_changed',
} as const;
